module.exports = {
  AtomicBoxPlugin: {
    PluginName: "AI Content Element",
    accordion_element: "Element",
    accordion_style: "Style",
    element_type: "Type",
    theme_id: "Theme",
    padding: "Padding",
    background_color: "Background",
    border_width: "Border size",
    border_style: "Border style",
    border_color: "Border color",
    border_radius: "Radius",
    opacity: "Opacity",
    loading: "Loading…",
    error: "Render unavailable",
    element_types: {
      heading: "Heading",
      eyebrow: "Eyebrow",
      footer: "Footer",
      quote: "Quote",
      "bullet-list": "Bullet List",
      "card-grid": "Card Grid",
      timeline: "Timeline",
      "stat-group": "Stats",
      hero: "Hero",
      section: "Section",
      "two-column": "Two Column",
      comparison: "Comparison",
      divider: "Divider",
      badge: "Badge",
      "cta-button": "CTA Button",
      "icon-block": "Icon Block",
    },
  },
};
